// src/components/Layout.js
import React from 'react';
import { Box, Container } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, user, setUser }) => {
  // cuando no hay usuario ( login, register, forgot-password) oculta header y footer
  const showHeaderFooter = Boolean(user);

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      {showHeaderFooter && <Header user={user} setUser={setUser} />}

    <Container maxWidth={false} disableGutters sx={{ flex: 1,  bgcolor: '#ECF3E0' }}>
      {children}
    </Container>


      {showHeaderFooter && <Footer />}
    </Box>
  );
};

export default Layout;

